import { Component, h, Host } from '@stencil/core';
import { theme } from '@eventstore-ui/theme';

/**
 * Displays Poo illustration.
 * @part illustration - The root svg of the illustration.
 */
@Component({
    tag: 'es-illustration-poo',
    styleUrl: 'poo.css',
    shadow: true,
})
export class EsIllustrationPoo {
    render() {
        const isDark = theme.isDark();

        return (
            <Host dark={isDark} light={!isDark}>
                {isDark ? this.renderDark() : this.renderLight()}
            </Host>
        );
    }

    renderLight() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enable-background="new 0 0 604.7 839.4"
                viewBox="0 0 604.7 839.4"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <linearGradient
                    id="poo_SVGID_1_"
                    x1="541.727"
                    x2="441.808"
                    y1="1007.115"
                    y2="875.575"
                    gradientTransform="translate(0 -238)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#BBDEFB" />
                    <stop offset="1" stop-color="#FFF" />
                </linearGradient>
                <path
                    d="M577 745c14.3-8.2 23.5-28.2 23.5-56.5 0-44.7-22.8-94.6-52.6-118.8l-152 88.1 28 168.7 5.4 3.3L577 745z"
                    class="poo_st0"
                />
                <linearGradient
                    id="poo_SVGID_00000160907178810693623410000014174151593340329140_"
                    x1="510.946"
                    x2="397.306"
                    y1="832.46"
                    y2="682.86"
                    gradientTransform="translate(0 -238)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#BBDEFB" />
                    <stop offset="1" stop-color="#FFF" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000160907178810693623410000014174151593340329140_)"
                    fill-rule="evenodd"
                    d="m393.9 658.4 153.9-89c-.1 0-.1 0-.1-.1 15-7.6 24.9-27.7 24.9-56.9 0-49.7-28.1-106.1-62.8-126.2l-11.5-6.6-151.9 87.2 47.5 191.6z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="poo_SVGID_00000025442330653803755130000006297566264908870537_"
                    x1="456.011"
                    x2="356.631"
                    y1="646.197"
                    y2="515.367"
                    gradientTransform="translate(0 -238)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#BBDEFB" />
                    <stop offset="1" stop-color="#FFF" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000025442330653803755130000006297566264908870537_)"
                    fill-rule="evenodd"
                    d="m344.1 467.5 153.8-88.2-.4-.2c11.7-7.8 19.3-24.8 19.3-48.8 0-44.1-25-94.4-55.8-112.1l-5-2.9-151.9 87.3 40 164.9z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="poo_SVGID_00000172433449808582269640000004338727132618529203_"
                    x1="412.147"
                    x2="275.237"
                    y1="482.252"
                    y2="302.032"
                    gradientTransform="translate(0 -238)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#BBDEFB" />
                    <stop offset="1" stop-color="#FFF" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000172433449808582269640000004338727132618529203_)"
                    fill-rule="evenodd"
                    d="M455.9 215.1c3.5-12 5.2-24.4 5.1-36.9C461 112 423.5 36.6 377.3 10c-4.1-2.4-8.5-4.3-13.1-5.7l-150 86 18.1 28.4-2.5 9.4 72.8 175.4 153.3-88.4z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="poo_SVGID_00000083778360721700025250000004357569658327176844_"
                    x1="-2394.966"
                    x2="-2438.346"
                    y1="100.865"
                    y2="43.755"
                    gradientTransform="rotate(180 -1118.65 134.5)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#BBDEFB" />
                    <stop offset="1" stop-color="#FFF" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000083778360721700025250000004357569658327176844_)"
                    fill-rule="evenodd"
                    d="m239.3 130-129.2 73s-9.7 30.2-8.6 36.3 21.5 3.6 22.6 5.8c-3.5 36.5 36.3-3.7 36.5-4.9l90.7-46.7-12-63.5z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="poo_SVGID_00000052076871259450537520000003727856816725081501_"
                    x1="-2387.222"
                    x2="-2448.182"
                    y1="-108.121"
                    y2="-188.381"
                    gradientTransform="rotate(180 -1118.65 134.5)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#BBDEFB" />
                    <stop offset="1" stop-color="#FFF" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000052076871259450537520000003727856816725081501_)"
                    fill-rule="evenodd"
                    d="m231.3 338.6-129.2 73.1s-9.7 30.2-8.6 36.3 21.5 3.5 22.6 5.7c-3.5 36.5 45.2 50.3 42.5 26.7l90-42.7-17.3-99.1z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="poo_SVGID_00000018959713566939198450000006608194180600142729_"
                    x1="-2480.526"
                    x2="-2541.496"
                    y1="-181.48"
                    y2="-261.73"
                    gradientTransform="rotate(180 -1118.65 134.5)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#BBDEFB" />
                    <stop offset="1" stop-color="#FFF" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000018959713566939198450000006608194180600142729_)"
                    fill-rule="evenodd"
                    d="m324.6 412-129.2 73s-9.7 30.2-8.6 36.3 21.6 3.6 22.7 5.8c-3.6 36.5 45.1 50.2 42.4 26.6l90-42.6-17.3-99.1z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="poo_SVGID_00000085936739394111875920000011074375604831297428_"
                    x1="-2409.247"
                    x2="-2520.537"
                    y1="-290.429"
                    y2="-436.919"
                    gradientTransform="rotate(180 -1118.65 134.5)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#BBDEFB" />
                    <stop offset="1" stop-color="#FFF" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000085936739394111875920000011074375604831297428_)"
                    fill-rule="evenodd"
                    d="m252.6 520-129.2 73s-9.7 30.2-8.6 36.3 21.6 3.6 22.7 5.8c-3.6 36.5 151.1 106.2 148.4 82.6l39.4-27.3L252.6 520z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="poo_SVGID_00000028314757102197880220000011965030028726923157_"
                    x1="111.059"
                    x2="87.599"
                    y1="564.126"
                    y2="533.236"
                    gradientTransform="translate(0 -238)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#BBDEFB" />
                    <stop offset="1" stop-color="#FFF" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000028314757102197880220000011965030028726923157_)"
                    fill-rule="evenodd"
                    d="m71.7 356.6 73.3-60.4-1.3-30.7-38.4 21.7v.5l-51.2 29.5 5.9 45.3c6.4-2.1 11.6-5.4 11.7-5.9z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="poo_SVGID_00000114766137990112580440000017073997132653713556_"
                    x1="76.5"
                    x2="66.29"
                    y1="684.012"
                    y2="670.582"
                    gradientTransform="translate(0 -238)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#BBDEFB" />
                    <stop offset="1" stop-color="#FFF" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000114766137990112580440000017073997132653713556_)"
                    fill-rule="evenodd"
                    d="M115.3 409.5 62.8 439.2 59.3 442.7 28 460.2 33.5 477 95.7 431.7z"
                    clip-rule="evenodd"
                />
                <path
                    d="M397.7 655.3c15-7.6 24.9-27.7 24.9-56.9 0-49.7-28.1-106.1-62.8-126.2l-12.3-7.1c11.7-7.8 19.3-24.8 19.3-48.8 0-44.1-25-94.4-55.8-112.1l-5.1-3c3.5-12 5.2-24.5 5.1-37 0-66.2-37.5-141.6-83.7-168.2-4.1-2.4-8.5-4.3-13.1-5.7 8.2 21 13.1 43.9 13.1 65.6 0 55.2-31.2 81.9-69.7 59.7l-13.9-8c-30.8-17.8-55.8 3.6-55.8 47.7 0 24 7.6 49.7 19.3 71.1l-12.3-7.1c-34.7-20.1-62.8 4-62.8 53.7 0 29.2 9.9 60.6 24.9 85.7-29.8-10.4-52.7 13.2-52.7 58 0 49.8 28 106.2 62.7 126.2l320.7 185.2c34.7 20 62.8-4 62.8-53.7 0-44.9-23-95-52.8-119.1zM171.6 383.5c15.4 8.9 27.9 34 27.9 56.1s-12.5 32.8-27.9 23.9-27.9-34-27.9-56.1 12.5-32.8 27.9-23.9zm-27 210.7c9.1-29.7 50.8-37 83-18.4s74 74.1 83.1 114.3c1.8 7.7-1.7 12.8-6.8 9.9l-152.6-88.1c-5-2.9-8.5-12.1-6.7-17.7zm138.5-66.3c-15.4-8.9-27.9-34-27.9-56.1s12.5-32.8 27.9-23.9 27.9 34 27.9 56.1-12.4 32.8-27.9 23.9z"
                    class="poo_st10"
                />
                <path
                    d="M169.6 572.2c6.6-2.6 13.6-3.9 20.7-3.8 12.6.1 25 3.5 35.9 9.8 29.3 17 64.9 63.6 78.1 100.5 1.7-1.1 3.4-2 5.1-2.9-6-16.4-16.2-34.9-29.3-52.6-16.5-22.5-35.1-40.7-51.1-49.9-19.4-11.2-43-13.7-61.5-6.4-5.7 2.2-10.9 5.4-15.3 9.6 1.3 1 2.5 2.1 3.5 3.4l.5.6c3.9-3.6 8.4-6.4 13.4-8.3zM302.3 695.7l-144.6-83.4c-.6 1.8-1.3 3.6-1.8 5.5l146.4 84.5v-6.6zM192.9 417.9l4.5-4.3c-5.2-14.2-14.1-26.6-24.4-32.5-7.3-4.2-14.5-4.7-20.3-1.3-2.8 1.7-5.1 4-6.8 6.8 1.5 1.2 2.9 2.5 4.2 3.9 1.3-2.4 3.1-4.4 5.4-5.8 1.7-1 3.7-1.5 5.7-1.5 3.2.1 6.3 1.1 9 2.8 9.6 5.6 18.1 18 22.7 31.9zM193.2 456.1c-1.2 2.5-3.1 4.7-5.5 6.2-4.1 2.3-9.2 1.9-14.7-1.3-8.5-4.9-16.1-15.1-20.9-26.9l-5.8 1c5.3 13.4 13.9 25.1 23.9 30.8 3.5 2.2 7.6 3.4 11.8 3.5 3 0 5.9-.7 8.5-2.2 3.3-2 6-4.9 7.7-8.4-1.7-.8-3.4-1.7-5-2.7zM131.3 203.7v1c0 .2-.1.4-.1.6 3.9 1 7.6 2.6 11.1 4.7l13.9 8c16.8 9.7 33.3 10.9 46.6 3.2 17.4-10 27.4-33.8 27.4-65.3v-1.3l-5.2-.4-.5.2v1.5c0 29.4-8.9 51.4-24.6 60.4-11.5 6.7-25.7 5.6-40.9-3.2l-13.9-8c-3.8-2.2-7.8-3.9-12-5.1-.3 1.3-.9 2.6-1.8 3.7zM327.3 321.1c1.3-1.3 2.7-2.6 4.2-3.7-5.5-6.2-12-11.5-19.1-15.7l-3.2-1.9c3.2-11.6 4.7-23.6 4.7-35.6 0-61.3-32-130.6-73.4-162.8-.5.5-1.1.9-1.8 1.1h-.1c-.9.4-2.4 2.1-2.9 2.4 41.2 30.2 72.5 98.4 72.5 159.3 0 12.2-1.6 24.4-5 36.2-.4 1.2.1 2.6 1.3 3.2l5.1 3c6.6 3.9 12.6 8.8 17.7 14.5zM419.1 610.5l5.4 2.4c.6-4.8.9-9.7.9-14.5 0-50.5-28.8-108.2-64.1-128.6l-8.7-5c10.9-9.6 17-27 17-48.5 0-6.1-.4-12.1-1.3-18.1l-5.4 1.9c.7 5.4 1.1 10.8 1.1 16.2 0 21.8-6.6 38.8-18 46.5-.8.5-1.3 1.4-1.3 2.4s.6 1.9 1.4 2.4l12.3 7.1c33.8 19.5 61.4 75 61.4 123.7-.1 4.2-.3 8.2-.7 12.1zM445.2 797.8l5 3.1c2.1-8.7 3.2-17.6 3.1-26.5 0-30.1-10.1-62.8-26.1-88.7l-4.1 2-.9.5c15.6 25.1 25.4 56.9 25.4 86.2.1 7.9-.7 15.7-2.4 23.4zM284.6 445.5c-7.3-4.2-14.5-4.7-20.4-1.3-.5.3-1 .6-1.4 1 1.2 1.4 2.3 3 3.3 4.6l1-.7c4-2.3 9.1-1.9 14.6 1.3 10.3 5.9 19.2 19.6 23.6 34.5 1.8-.7 3.8-.9 5.7-.7-4.6-16.7-14.6-31.9-26.4-38.7zM302.7 525.1l-.8-.6c-.8.9-1.7 1.6-2.7 2.2-4.1 2.3-9.1 1.9-14.6-1.3h-.1c-10.4-6.1-19.5-20.1-23.7-35.3l-.4-.2c-2 0-3.9-.3-5.8-.7 4.4 17.6 14.7 34 27.1 41.1 0 .1 0 .1.1.1 3.6 2.2 7.6 3.4 11.8 3.5 3 0 5.9-.8 8.4-2.3.9-.5 1.7-1.1 2.5-1.7-.7-1.6-1.2-3.2-1.8-4.8z"
                    class="poo_st11"
                />
                <path
                    d="M600.5 688.4c0-44.9-23-95-52.8-119.1 15-7.6 24.9-27.7 24.9-56.9 0-49.7-28.1-106.1-62.8-126.2l-12.3-7.1c11.7-7.8 19.3-24.8 19.3-48.8 0-44.1-25-94.4-55.8-112.1l-5.1-3c3.5-12 5.2-24.5 5.1-37C461 112 423.5 36.6 377.3 10c-4.1-2.4-8.5-4.3-13.1-5.7h0l-150 86h0c6 15.4 10.1 31.6 12.1 48l-116.7 66.3c-13.2 7-21.7 25-21.7 50.7.1 13.2 2.2 26.4 6 39l-37.5 21.6-1.7 1-.6.3h0c-13.4 8.7-22 28.3-22 55.7 0 25 7.2 51.6 18.8 74.4L28 460.2h0c-14.4 8.1-23.7 28-23.7 56.5 0 49.8 28 106.2 62.7 126.2l320.7 185.2c15.9 9.1 30.4 9.1 41.4 1.5h.2L577 745h0c14.3-8.3 23.5-28.3 23.5-56.6z"
                    class="poo_st12"
                />
            </svg>
        );
    }

    renderDark() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enable-background="new 0 0 604.7 839.4"
                viewBox="0 0 604.7 839.4"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <linearGradient
                    id="poo_SVGID_1_"
                    x1="541.727"
                    x2="441.808"
                    y1="1007.115"
                    y2="875.575"
                    gradientTransform="translate(0 -238)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#09264A" />
                    <stop offset="1" stop-color="#CED4DB" />
                </linearGradient>
                <path
                    d="M577 745c14.3-8.2 23.5-28.2 23.5-56.5 0-44.7-22.8-94.6-52.6-118.8l-152 88.1 28 168.7 5.4 3.3L577 745z"
                    class="poo_st0"
                />
                <linearGradient
                    id="poo_SVGID_00000171710855110913778660000008976721504688416700_"
                    x1="510.946"
                    x2="397.306"
                    y1="832.46"
                    y2="682.86"
                    gradientTransform="translate(0 -238)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#09264A" />
                    <stop offset="1" stop-color="#CED4DB" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000171710855110913778660000008976721504688416700_)"
                    fill-rule="evenodd"
                    d="m393.9 658.4 153.9-89c-.1 0-.1 0-.1-.1 15-7.6 24.9-27.7 24.9-56.9 0-49.7-28.1-106.1-62.8-126.2l-11.5-6.6-151.9 87.2 47.5 191.6z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="poo_SVGID_00000103964359953527911750000001107902308770474902_"
                    x1="456.011"
                    x2="356.631"
                    y1="646.197"
                    y2="515.367"
                    gradientTransform="translate(0 -238)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#09264A" />
                    <stop offset="1" stop-color="#CED4DB" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000103964359953527911750000001107902308770474902_)"
                    fill-rule="evenodd"
                    d="m344.1 467.5 153.8-88.2-.4-.2c11.7-7.8 19.3-24.8 19.3-48.8 0-44.1-25-94.4-55.8-112.1l-5-2.9-151.9 87.3 40 164.9z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="poo_SVGID_00000111874519231890330290000000974900195560585880_"
                    x1="412.147"
                    x2="275.237"
                    y1="482.252"
                    y2="302.032"
                    gradientTransform="translate(0 -238)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#09264A" />
                    <stop offset="1" stop-color="#CED4DB" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000111874519231890330290000000974900195560585880_)"
                    fill-rule="evenodd"
                    d="M455.9 215.1c3.5-12 5.2-24.4 5.1-36.9C461 112 423.5 36.6 377.3 10c-4.1-2.4-8.5-4.3-13.1-5.7l-150 86 18.1 28.4-2.5 9.4 72.8 175.4 153.3-88.4z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="poo_SVGID_00000150822554200259768240000009787886599958040765_"
                    x1="-2394.966"
                    x2="-2438.346"
                    y1="100.865"
                    y2="43.755"
                    gradientTransform="rotate(180 -1118.65 134.5)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#09264A" />
                    <stop offset="1" stop-color="#CED4DB" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000150822554200259768240000009787886599958040765_)"
                    fill-rule="evenodd"
                    d="m239.3 130-129.2 73s-9.7 30.2-8.6 36.3 21.5 3.6 22.6 5.8c-3.5 36.5 36.3-3.7 36.5-4.9l90.7-46.7-12-63.5z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="poo_SVGID_00000116193537147076173730000002927744730195190691_"
                    x1="-2387.222"
                    x2="-2448.182"
                    y1="-108.121"
                    y2="-188.381"
                    gradientTransform="rotate(180 -1118.65 134.5)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#09264A" />
                    <stop offset="1" stop-color="#CED4DB" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000116193537147076173730000002927744730195190691_)"
                    fill-rule="evenodd"
                    d="m231.3 338.6-129.2 73.1s-9.7 30.2-8.6 36.3 21.5 3.5 22.6 5.7c-3.5 36.5 45.2 50.3 42.5 26.7l90-42.7-17.3-99.1z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="poo_SVGID_00000156566965695375867380000011538569357505522589_"
                    x1="-2480.526"
                    x2="-2541.496"
                    y1="-181.48"
                    y2="-261.73"
                    gradientTransform="rotate(180 -1118.65 134.5)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#09264A" />
                    <stop offset="1" stop-color="#CED4DB" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000156566965695375867380000011538569357505522589_)"
                    fill-rule="evenodd"
                    d="m324.6 412-129.2 73s-9.7 30.2-8.6 36.3 21.6 3.6 22.7 5.8c-3.6 36.5 45.1 50.2 42.4 26.6l90-42.6-17.3-99.1z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="poo_SVGID_00000021805848178508202470000009789173968180673181_"
                    x1="-2409.247"
                    x2="-2520.537"
                    y1="-290.429"
                    y2="-436.919"
                    gradientTransform="rotate(180 -1118.65 134.5)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#09264A" />
                    <stop offset="1" stop-color="#CED4DB" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000021805848178508202470000009789173968180673181_)"
                    fill-rule="evenodd"
                    d="m252.6 520-129.2 73s-9.7 30.2-8.6 36.3 21.6 3.6 22.7 5.8c-3.6 36.5 151.1 106.2 148.4 82.6l39.4-27.3L252.6 520z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="poo_SVGID_00000060030171885960484900000004744351532144937366_"
                    x1="111.059"
                    x2="87.599"
                    y1="564.126"
                    y2="533.236"
                    gradientTransform="translate(0 -238)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#09264A" />
                    <stop offset="1" stop-color="#CED4DB" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000060030171885960484900000004744351532144937366_)"
                    fill-rule="evenodd"
                    d="m71.7 356.6 73.3-60.4-1.3-30.7-38.4 21.7v.5l-51.2 29.5 5.9 45.3c6.4-2.1 11.6-5.4 11.7-5.9z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="poo_SVGID_00000059290416733611017630000010563165567599661706_"
                    x1="76.5"
                    x2="66.29"
                    y1="684.012"
                    y2="670.582"
                    gradientTransform="translate(0 -238)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#BBDEFB" />
                    <stop offset="1" stop-color="#FFF" />
                </linearGradient>
                <path
                    fill="url(#poo_SVGID_00000059290416733611017630000010563165567599661706_)"
                    fill-rule="evenodd"
                    d="M115.3 409.5 62.8 439.2 59.3 442.7 28 460.2 33.5 477 95.7 431.7z"
                    clip-rule="evenodd"
                />
                <path
                    d="M397.7 655.3c15-7.6 24.9-27.7 24.9-56.9 0-49.7-28.1-106.1-62.8-126.2l-12.3-7.1c11.7-7.8 19.3-24.8 19.3-48.8 0-44.1-25-94.4-55.8-112.1l-5.1-3c3.5-12 5.2-24.5 5.1-37 0-66.2-37.5-141.6-83.7-168.2-4.1-2.4-8.5-4.3-13.1-5.7 8.2 21 13.1 43.9 13.1 65.6 0 55.2-31.2 81.9-69.7 59.7l-13.9-8c-30.8-17.8-55.8 3.6-55.8 47.7 0 24 7.6 49.7 19.3 71.1l-12.3-7.1c-34.7-20.1-62.8 4-62.8 53.7 0 29.2 9.9 60.6 24.9 85.7-29.8-10.4-52.7 13.2-52.7 58 0 49.8 28 106.2 62.7 126.2l320.7 185.2c34.7 20 62.8-4 62.8-53.7 0-44.9-23-95-52.8-119.1zM171.6 383.5c15.4 8.9 27.9 34 27.9 56.1s-12.5 32.8-27.9 23.9-27.9-34-27.9-56.1 12.5-32.8 27.9-23.9zm-27 210.7c9.1-29.7 50.8-37 83-18.4s74 74.1 83.1 114.3c1.8 7.7-1.7 12.8-6.8 9.9l-152.6-88.1c-5-2.9-8.5-12.1-6.7-17.7zm138.5-66.3c-15.4-8.9-27.9-34-27.9-56.1s12.5-32.8 27.9-23.9 27.9 34 27.9 56.1-12.4 32.8-27.9 23.9z"
                    class="poo_st10"
                />
                <path
                    d="M169.6 572.2c6.6-2.6 13.6-3.9 20.7-3.8 12.6.1 25 3.5 35.9 9.8 29.3 17 64.9 63.6 78.1 100.5 1.7-1.1 3.4-2 5.1-2.9-6-16.4-16.2-34.9-29.3-52.6-16.5-22.5-35.1-40.7-51.1-49.9-19.4-11.2-43-13.7-61.5-6.4-5.7 2.2-10.9 5.4-15.3 9.6 1.3 1 2.5 2.1 3.5 3.4l.5.6c3.9-3.6 8.4-6.4 13.4-8.3zM302.3 695.7l-144.6-83.4c-.6 1.8-1.3 3.6-1.8 5.5l146.4 84.5v-6.6zM192.9 417.9l4.5-4.3c-5.2-14.2-14.1-26.6-24.4-32.5-7.3-4.2-14.5-4.7-20.3-1.3-2.8 1.7-5.1 4-6.8 6.8 1.5 1.2 2.9 2.5 4.2 3.9 1.3-2.4 3.1-4.4 5.4-5.8 1.7-1 3.7-1.5 5.7-1.5 3.2.1 6.3 1.1 9 2.8 9.6 5.6 18.1 18 22.7 31.9zM193.2 456.1c-1.2 2.5-3.1 4.7-5.5 6.2-4.1 2.3-9.2 1.9-14.7-1.3-8.5-4.9-16.1-15.1-20.9-26.9l-5.8 1c5.3 13.4 13.9 25.1 23.9 30.8 3.5 2.2 7.6 3.4 11.8 3.5 3 0 5.9-.7 8.5-2.2 3.3-2 6-4.9 7.7-8.4-1.7-.8-3.4-1.7-5-2.7zM131.3 203.7v1c0 .2-.1.4-.1.6 3.9 1 7.6 2.6 11.1 4.7l13.9 8c16.8 9.7 33.3 10.9 46.6 3.2 17.4-10 27.4-33.8 27.4-65.3v-1.3l-5.2-.4-.5.2v1.5c0 29.4-8.9 51.4-24.6 60.4-11.5 6.7-25.7 5.6-40.9-3.2l-13.9-8c-3.8-2.2-7.8-3.9-12-5.1-.3 1.3-.9 2.6-1.8 3.7zM327.3 321.1c1.3-1.3 2.7-2.6 4.2-3.7-5.5-6.2-12-11.5-19.1-15.7l-3.2-1.9c3.2-11.6 4.7-23.6 4.7-35.6 0-61.3-32-130.6-73.4-162.8-.5.5-1.1.9-1.8 1.1h-.1c-.9.4-2.4 2.1-2.9 2.4 41.2 30.2 72.5 98.4 72.5 159.3 0 12.2-1.6 24.4-5 36.2-.4 1.2.1 2.6 1.3 3.2l5.1 3c6.6 3.9 12.6 8.8 17.7 14.5zM419.1 610.5l5.4 2.4c.6-4.8.9-9.7.9-14.5 0-50.5-28.8-108.2-64.1-128.6l-8.7-5c10.9-9.6 17-27 17-48.5 0-6.1-.4-12.1-1.3-18.1l-5.4 1.9c.7 5.4 1.1 10.8 1.1 16.2 0 21.8-6.6 38.8-18 46.5-.8.5-1.3 1.4-1.3 2.4s.6 1.9 1.4 2.4l12.3 7.1c33.8 19.5 61.4 75 61.4 123.7-.1 4.2-.3 8.2-.7 12.1zM445.2 797.8l5 3.1c2.1-8.7 3.2-17.6 3.1-26.5 0-30.1-10.1-62.8-26.1-88.7l-4.1 2-.9.5c15.6 25.1 25.4 56.9 25.4 86.2.1 7.9-.7 15.7-2.4 23.4zM284.6 445.5c-7.3-4.2-14.5-4.7-20.4-1.3-.5.3-1 .6-1.4 1 1.2 1.4 2.3 3 3.3 4.6l1-.7c4-2.3 9.1-1.9 14.6 1.3 10.3 5.9 19.2 19.6 23.6 34.5 1.8-.7 3.8-.9 5.7-.7-4.6-16.7-14.6-31.9-26.4-38.7zM302.7 525.1l-.8-.6c-.8.9-1.7 1.6-2.7 2.2-4.1 2.3-9.1 1.9-14.6-1.3h-.1c-10.4-6.1-19.5-20.1-23.7-35.3l-.4-.2c-2 0-3.9-.3-5.8-.7 4.4 17.6 14.7 34 27.1 41.1 0 .1 0 .1.1.1 3.6 2.2 7.6 3.4 11.8 3.5 3 0 5.9-.8 8.4-2.3.9-.5 1.7-1.1 2.5-1.7-.7-1.6-1.2-3.2-1.8-4.8z"
                    class="poo_st11"
                />
                <path
                    d="M600.5 688.4c0-44.9-23-95-52.8-119.1 15-7.6 24.9-27.7 24.9-56.9 0-49.7-28.1-106.1-62.8-126.2l-12.3-7.1c11.7-7.8 19.3-24.8 19.3-48.8 0-44.1-25-94.4-55.8-112.1l-5.1-3c3.5-12 5.2-24.5 5.1-37C461 112 423.5 36.6 377.3 10c-4.1-2.4-8.5-4.3-13.1-5.7h0l-150 86h0c6 15.4 10.1 31.6 12.1 48l-116.7 66.3c-13.2 7-21.7 25-21.7 50.7.1 13.2 2.2 26.4 6 39l-37.5 21.6-1.7 1-.6.3h0c-13.4 8.7-22 28.3-22 55.7 0 25 7.2 51.6 18.8 74.4L28 460.2h0c-14.4 8.1-23.7 28-23.7 56.5 0 49.8 28 106.2 62.7 126.2l320.7 185.2c15.9 9.1 30.4 9.1 41.4 1.5h.2L577 745h0c14.3-8.3 23.5-28.3 23.5-56.6z"
                    class="poo_st12"
                />
            </svg>
        );
    }
}
